import { createClient } from '@supabase/supabase-js'

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_KEY
)

export async function login(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password })
  if (error) throw new Error(error.message)

  // Verificar que es super admin
  const { data: adminData, error: adminError } = await supabase
    .from('super_admins')
    .select('*')
    .eq('email', email)
    .eq('is_active', true)
    .single()

  if (adminError || !adminData) {
    await supabase.auth.signOut()
    throw new Error('Access denied. You are not authorized to access this panel.')
  }

  return data.user
}

export async function logout() {
  await supabase.auth.signOut()
}

export async function getCurrentUser() {
  const { data } = await supabase.auth.getSession()
  if (!data.session) return null

  const { data: adminData } = await supabase
    .from('super_admins')
    .select('*')
    .eq('email', data.session.user.email)
    .eq('is_active', true)
    .single()

  if (!adminData) return null
  return data.session.user
}